// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ReactDOM from 'react-dom';
interface TextEditorProps extends React.PropsWithChildren<{}> {
    defaultText: string;
    onChange: (value: string) => void;
    width: number;
    height: number;
}

class TextEditor extends React.Component<TextEditorProps, any> {
    constructor(props: TextEditorProps) {
        super(props);

    }

    private _getOptions = (props: TextEditorProps) => {
        var options: any = {
            keyup: function (args: any) {
                props.onChange(this.getHtml().split(' target="">').join(' target="_blank">'));
            },
            change: function () {
                props.onChange(this.getHtml().split(' target="">').join(' target="_blank">'));
            },
            enableHtmlEncode: false,
            value: this.props.defaultText ? this.props.defaultText : '',
            width: this.props.width,
            height: this.props.height,
            toolsList: ["formatStyle", "font", "style", "effects", "alignment", "lists", "indenting", "clipboard", "doAction", "clear", "links", "tables", "casing"],
            locale: InovxLoader.getSyncfusionLocale()
        };
        return options;
    }

    shouldComponentUpdate(nextProps: TextEditorProps, nextState: any) {
        // Never update this component...
        return false;
    }

    componentDidMount() {
        var container = $(ReactDOM.findDOMNode(this)) as any;

        var rte = container.ejRTE(this._getOptions(this.props));
    }

    UNSAFE_componentWillReceiveProps(nextProps: TextEditorProps) {
        var rte = ($(ReactDOM.findDOMNode(this)) as any).data("ejRTE");
        if (rte) {
            rte.value(nextProps.defaultText);
            rte.refresh();
        }
        
    }

    componentWillUnmount() {
        var rte = ($(ReactDOM.findDOMNode(this)) as any).data("ejRTE");
        rte.destroy();
    }

    render() {
        return <textarea className='text-editor' />;
    }

}

export default TextEditor;